// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"1a02a0e7","496":"5bc46b78","743":"636e32ab"}[chunkId] + ".chunk.js";
};